import type { LanguageCode } from "config/languages";
import { getLocaleByLanguage } from "utils/getLocaleByLanguage";
import type { Currencies } from "./currencies.d";

export const formatCurrency = (value: number, language: LanguageCode, fixedCurrency?: Currencies, precision = 0) => {
  const locale = getLocaleByLanguage(language);

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: fixedCurrency,
    minimumFractionDigits: precision,
  }).format(value);
};
